module.exports = __webpack_public_path__ + "img/minus.86be4633.svg";